module.exports = __webpack_public_path__ + "static/media/Japanese_Akira BG-20.286bf5f5.png";